import { TypeTextFormatted } from "@contentful/types";
import { RichText } from "./rich-text/RichText";

export function TextFormatted({
  textFormatted,
}: {
  textFormatted: TypeTextFormatted<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  return (
    textFormatted.fields.formattedText && (
      <RichText
        content={textFormatted.fields.formattedText}
        className="m-auto max-w-[1400px] px-5 pb-12 max-md:pt-5"
        ulClassName="ml-7"
      />
    )
  );
}
